import { Component, OnInit } from '@angular/core';
import {BinsService} from '../core/data-sources/bins.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor(private binsService: BinsService) { }

  ngOnInit(): void {
  }

}
